// Сетка стандартных сечений с возможностью выбора

import type { SectionGridProps } from '../../types';
import './Results.css';

export function SectionGrid({
  sections,
  selectedSection,
  recommendedSection,
  onSectionChange,
  disabled = false,
}: SectionGridProps) {
  const getClassName = (section: number) => {
    const classes = ['section-grid__item'];
    
    if (section === selectedSection) {
      classes.push('section-grid__item--selected');
    }
    if (recommendedSection !== undefined && section === recommendedSection) {
      classes.push('section-grid__item--recommended');
    }
    if (disabled) {
      classes.push('section-grid__item--disabled');
    }
    
    return classes.join(' ');
  };

  const handleClick = (section: number) => {
    if (!disabled) {
      onSectionChange(section);
    }
  };

  return (
    <div className="section-grid">
      {sections.map((section) => (
        <button
          key={section}
          type="button"
          className={getClassName(section)}
          onClick={() => handleClick(section)}
          disabled={disabled}
        >
          {section}
        </button>
      ))}
    </div>
  );
}
